<div class="go-container">

  <go-card class="go-column go-column--100" id="usage">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Usage</h2>
      <go-copy cardId="usage" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          The <code class="code-block--inline">&lt;go-side-nav&gt;</code> component should only be used once, at the root level component.
          It should be placed inside a <code class="code-block--inline">&lt;go-layout&gt;</code> and be given the attribute of 
          <code class="code-block--inline">go-layout-nav</code>.
          This component will generate a set of links and accordions on the left of the application and uses the built in routing provided
          by Angular.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h3 class="go-heading-3">Bindings</h3>
        <code [highlight]="componentBindings"></code>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">menuItems</h4>
        <p class="go-body-copy">
          The data passed to this binding contains the structure of the navigation. There are variations of how this
          data could look, but it has to conform to either a <code class="code-block--inline">NavItem</code> or a
          <code class="code-block--inline">NavGroup</code> model. These models have the following properties:
        </p>
        <code [highlight]="bindings_menuItems"></code>
        <p class="go-body-copy">
          Setting a value for <code class="code-block--inline">attributes</code> on a <code class="code-block--inline">NavItem</code>
          or <code class="code-block--inline">NavGroup</code> will add html attributes to the top level html element for
          that menu item with the names and values you specify. The <code class="code-block--inline">CustomNavAttributes</code>
          model, which defines how the value of each item in the array set to <code class="code-block--inline">attributes</code>
          should be structured, has the following properties:
        </p>
        <code [highlight]="bindings_attributes"></code>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">navAppDrawer</h4>
        <p class="go-body-copy">
          Optional binding to render app drawer within side navigation. Please reference
          <a class="go-link" [routerLink]="['/ui-kit/layout/app-drawer']">App Drawer Documentation</a> for implementation details.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">appDrawerHeader</h4>
        <p class="go-body-copy">
          Optional <code class="code-block--inline">string</code> binding to set the header of the app drawer. This is defaulted to 'Launch'.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding" id="important-notes">
        <h3 class="go-heading-3">Important Notes:</h3>
        <ol class="go-list go-list--ordered">
          <li>
            Providing data to <code class="code-block--inline">menuItems</code> does not mean you no longer have
            to define your Angular routes. You still have to do this.
          </li>
          <li>
            Root level navigation elements must have an icon associated with them, but any other level underneath should not.
          </li>
          <li>
            <code class="code-block--inline">NavGroup</code> objects will not prodive routing themselves, any routes should be defined
            within the <code class="code-block--inline">subRoutes</code> array. If there are no <code class="code-block--inline">subRoutes</code>
            for this object, then it should be a <code class="code-block--inline">NavItem</code> instead.
          </li>
          <li>
            The maximum number of levels that should be nested is 2. Exceeding this number breaks the experience.
          </li>
          <li>
            The full route should be provided from root.
            (ex: ui-kit has a child of button, the route provided should be <code class="code-block--inline">'ui-kit/button'</code>)
          </li>
          <li>
            Lastly, for security reasons, the data provided for <code class="code-block--inline">menuItems</code> should be generated
            and obtained from the server. There is no functionality in place to show/hide routes within this component. Any behavior of this
            kind should be generated by the server.
          </li>
        </ol>
      </div>

    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="setup">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Simple Setup</h2>
      <go-copy cardId="setup" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100 go-column--no-padding">
        <p class="go-body-copy">
          For the sake of this example, we'll be referencing the layout of this application because it's a living example of the
          entire layout component and family. It is also being shown inside of the layout component because it's required to be inside it.
        </p>
        
        <h4 class="go-heading-4">app.module</h4>
        <code [highlight]="basicExample_module"></code>
        
        <h4 class="go-heading-4">app.component.html</h4>
        <code [highlight]="basicExample_html"></code>
        
        <h4 class="go-heading-4">app.component.ts</h4>
        <code [highlight]="basicExample_ts"></code>
      </div>

    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="service">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Side Nav Service</h2>
      <go-copy cardId="service" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100 go-column--no-padding">
        <p class="go-body-copy">
          If there is an instance where the side nav needs collapsed based on some action performed in the rest of 
          the UI the <code class="code-block--inline">GoSideNavService</code> can be used. Note: the <code class="code-block--inline">GoHeaderComponent</code>
          handles expanding/collapsing of the navigation and should be used as the primary way to do this.
        </p>
        
        <h4 class="go-heading-4">component.ts</h4>
        <code [highlight]="serviceExample_ts"></code>
      </div>

    </div>
  </go-card>

</div>
